import * as types from "./mutation-types";

export default {
  [types.SET_TRADE_IDEAS](state, payload) {
    state.tradeIdeas = payload;
  },
  [types.SET_HISTORY_TRADE_IDEAS](state, payload) {
    state.historyTradeIdeas = payload;
  },
  [types.SET_LOADING](state, payload) {
    state.isLoading = payload;
  },
  [types.SET_RESET_TRADE_IDEAS](state) {
    state.tradeIdeas = [];
  },
  [types.SET_RESET_HISTORY_TRADE_IDEAS](state) {
    state.historyTradeIdeas = [];
  },
};
